export const updateRange = (startTime, endTime) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({type:"UPDATE_RANGE", startTime, endTime});
  }
}